import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-100 via-accent-50 to-secondary-100 p-8 md:p-12 border border-primary-200/50">
          <div className="absolute top-0 right-0 w-48 h-48 bg-primary-200/30 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-36 h-36 bg-accent-200/30 rounded-full translate-y-1/2 -translate-x-1/2"></div>

          <div className="relative z-10 text-center">
            <span className="inline-block px-3 py-1 bg-background-50/80 text-primary-700 text-xs font-semibold rounded-full mb-4 backdrop-blur-sm">
              Polecane artykuły
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Poznaj Kakobuy Spreadsheet od podstaw
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
              Przeczytaj nasze szczegółowe poradniki i zostań ekspertem Kakobuy. Dowiedz się jak bezpiecznie kupować, znajdować najlepsze okazje i oszczędzać czas.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/blog/kakobuy-spreadsheet-polska-przewodnik"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-article-line text-lg"></i>
                Kompletny przewodnik
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/blog/kakobuy-bezpieczenstwo"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-background-50 text-foreground-700 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer border border-background-200/70 no-underline"
              >
                <i className="ri-shield-check-line"></i>
                Bezpieczeństwo Kakobuy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}